import { Injectable } from "@angular/core";
var PngDecoder = (function () {
    function PngDecoder() {
        this.canvas = document.createElement("canvas");
        this.context = (this.canvas.getContext("2D"));
    }
    ;
    PngDecoder.prototype.decode = function (data) {
        var _this = this;
        var dataLoaded = new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function (event) {
                _this.canvas.height = img.height;
                _this.canvas.width = img.width;
                _this.context.drawImage(img, 0, 0);
                var decodedData = _this.context.getImageData(0, 0, img.width, img.height);
                window.URL.revokeObjectURL(img.src);
                resolve(decodedData);
            };
            img.src = window.URL.createObjectURL(data);
        });
        return dataLoaded;
    };
    ;
    PngDecoder.decorators = [
        { type: Injectable },
    ];
    PngDecoder.ctorParameters = function () { return []; };
    return PngDecoder;
}());
export { PngDecoder };
;
//# sourceMappingURL=png-decoder.js.map